/* Boonsoir 2.0 — shared behaviour. No dependencies. */
(() => {
  const root = document.documentElement;
  root.classList.remove('no-js');
  root.classList.add('js');
  const routes = (window.Boonsoir && window.Boonsoir.routes) || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Header scroll state ---------- */
  const header = document.querySelector('[data-site-header]');
  if (header) {
    // motion.js owns the scroll loop; this is the fallback when it is missing
    const onScroll = () => { if (window.BoonsoirMotion) return; header.classList.toggle('is-scrolled', window.scrollY > 4); };
    let queued = false;
    onScroll();
    window.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; onScroll(); }); } }, { passive: true });
  }

  /* ---------- Focus trap helper ---------- */
  const focusables = (el) => [...el.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])')].filter((n) => n.offsetParent !== null);
  function trap(el, e) {
    if (e.key !== 'Tab') return;
    const f = focusables(el);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- Mobile menu ---------- */
  const sheet = document.querySelector('[data-menu-sheet]');
  let menuOpener = null;
  function openMenu(btn) {
    if (!sheet) return;
    menuOpener = btn;
    sheet.hidden = false;
    void sheet.offsetWidth; // commit the closed state so the opening transition runs
    sheet.classList.add('is-open');
    document.querySelectorAll('[data-menu-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    document.body.style.overflow = 'hidden';
    // focus once the sheet is visible (a visibility:hidden element cannot take focus)
    const close = sheet.querySelector('[data-menu-close]');
    if (close) requestAnimationFrame(() => close.focus({ preventScroll: true }));
  }
  function closeMenu() {
    if (!sheet || !sheet.classList.contains('is-open')) return;
    sheet.classList.remove('is-open');
    document.querySelectorAll('[data-menu-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    document.body.style.overflow = '';
    setTimeout(() => { if (!sheet.classList.contains('is-open')) sheet.hidden = true; }, 400);
    if (menuOpener) menuOpener.focus();
  }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-menu-toggle]');
    if (t) { e.preventDefault(); openMenu(t); return; }
    if (e.target.closest('[data-menu-close]')) { e.preventDefault(); closeMenu(); return; }
    if (sheet && e.target.closest('[data-menu-sheet] a')) closeMenu();
  });
  if (sheet) sheet.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMenu(); trap(sheet, e); });

  /* ---------- Cart drawer ---------- */
  const drawerSel = '[data-cart-drawer]';
  let drawerOpener = null;
  const getDrawer = () => document.querySelector(drawerSel);
  function openDrawer(opener) {
    const d = getDrawer();
    if (!d) { window.location.href = routes.cart_url; return; }
    drawerOpener = opener || document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const panel = d.querySelector('.drawer__panel');
    setTimeout(() => { const c = d.querySelector('[data-drawer-close]'); (c || panel).focus(); }, 60);
  }
  function closeDrawer() {
    const d = getDrawer();
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (drawerOpener && document.contains(drawerOpener)) drawerOpener.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && getDrawer()) { e.preventDefault(); openDrawer(opener); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', (e) => {
    const d = getDrawer();
    if (!d || !d.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeDrawer();
    trap(d.querySelector('.drawer__panel'), e);
  });

  /* Section Rendering: replace drawer + cart counters */
  const SECTIONS = ['cart-drawer', 'cart-count'];
  let cartAddQueue = Promise.resolve();
  function syncPackageBook() {
    const inner = document.querySelector('[data-cart-drawer-inner]');
    if (!inner) return;
    const present = Number(inner.dataset.bookCount || 0) > 0;
    document.querySelectorAll('[data-book-buy]').forEach((button) => {
      button.disabled = present;
      button.querySelector('span').textContent = present ? 'Zit al in je mandje' : 'In mijn mandje';
    });
    document.querySelectorAll('[data-package-book]').forEach((box) => {
      box.disabled = present;
      if (present) box.checked = true;
      else if (box.dataset.inCart === 'true') box.checked = false;
      box.dataset.inCart = String(present);
      const status = box.closest('[data-package-book-row]').querySelector('[data-package-book-status]');
      if (status) status.textContent = present ? 'Zit al in je mandje' : 'Eén pdf voor je hele bestelling · per e-mail';
    });
  }
  document.addEventListener('cart:updated', syncPackageBook);
  document.addEventListener('DOMContentLoaded', syncPackageBook);
  function renderSections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const fresh = html.querySelector('[data-cart-drawer-inner]');
      const current = document.querySelector('[data-cart-drawer-inner]');
      if (fresh && current) current.replaceWith(fresh);
    }
    if (sections['cart-count']) {
      const html = new DOMParser().parseFromString(sections['cart-count'], 'text/html');
      const count = html.querySelector('[data-cart-count-value]');
      if (count) document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = count.textContent.trim(); });
    }
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function toast(msg, ms = 3200) {
    let t = document.querySelector('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t._h);
    t._h = setTimeout(() => t.classList.remove('is-on'), ms);
  }

  /* Shopify's cart errors arrive in English; say it in Dutch. */
  function cartError(data, status) {
    const raw = String((data && (data.description || data.message)) || '');
    const left = /only (\d+) /i.exec(raw) || /(\d+) in stock/i.exec(raw) || /(\d+) (?:items?|stuks?)/i.exec(raw);
    if (/all (\d+) are in your cart|already in your cart/i.test(raw)) return 'Alles wat we hebben zit al in je mandje.';
    if (left && /stock|voorraad|only|available/i.test(raw)) return `Er zijn er nog maar ${left[1]} op voorraad.`;
    if (/sold out|not available|unavailable|uitverkocht/i.test(raw)) return 'Deze is even uitverkocht.';
    if (/cannot find|not found|variant/i.test(raw) || status === 404) return 'Dit product is even niet beschikbaar. Probeer het opnieuw of mail ons.';
    if (/too many|limit/i.test(raw)) return 'Zoveel kunnen we er niet in één bestelling meesturen.';
    return 'Toevoegen lukte niet. Probeer het nog eens of mail ons.';
  }

  async function postJSON(url, body) {
    const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(cartError(data, res.status));
    return data;
  }

  /* Ajax add for any form[data-ajax-cart] (single id or items[]) */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form || !getDrawer()) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    if (btn && btn.classList.contains('is-loading')) return; // one add at a time
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    const previousAdd = cartAddQueue;
    let releaseAdd;
    cartAddQueue = new Promise((resolve) => { releaseAdd = resolve; });
    try {
      await previousAdd;
      const fd = new FormData(form);
      const bookId = document.querySelector('[data-book-variant-id]')?.dataset.bookVariantId;
      const ids = [...fd.entries()].filter(([name]) => name === 'id' || /^items\[\d+\]\[id\]$/.test(name));
      let hasBook = false;
      for (const [name, id] of ids) {
        const prefix = name === 'id' ? '' : name.slice(0, -4);
        const qtyName = prefix ? `${prefix}[quantity]` : 'quantity';
        if (Number(fd.get(qtyName) ?? 1) === 0) {
          for (const key of [...fd.keys()]) if (prefix && key.startsWith(prefix + '[')) fd.delete(key);
        } else if (bookId && String(id) === bookId) {
          fd.set(qtyName, '1');
          hasBook = true;
        }
      }
      if (hasBook) {
        const cartRes = await fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!cartRes.ok) throw new Error('Je mandje controleren lukte niet. Probeer het opnieuw.');
        const cart = await cartRes.json();
        if (cart.items.some((item) => String(item.variant_id) === bookId && item.quantity > 0)) {
          for (const [name, id] of ids) {
            if (String(id) !== bookId) continue;
            if (name === 'id') { fd.delete('id'); fd.delete('quantity'); }
            else {
              const prefix = name.slice(0, -4);
              for (const key of [...fd.keys()]) if (key.startsWith(prefix + '[')) fd.delete(key);
            }
          }
          toast('Het drankenboek zit al in je mandje. Eén pdf is genoeg voor je bestelling.');
        }
      }
      if (![...fd.keys()].some((name) => name === 'id' || /^items\[\d+\]\[id\]$/.test(name))) {
        const res = await fetch(routes.cart_url + '?sections=' + SECTIONS.join(','));
        if (!res.ok) throw new Error('Je mandje verversen lukte niet. Probeer het opnieuw.');
        renderSections(await res.json());
        openDrawer(btn);
        return;
      }
      fd.append('sections', SECTIONS.join(','));
      fd.append('sections_url', window.location.pathname);
      const res = await fetch(routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data.status) throw new Error(cartError(data, res.status));
      renderSections(data.sections);
      document.dispatchEvent(new CustomEvent('cart:add:success', { detail: { form } }));
      // motion.js flies the pouch to the cart pill first; the drawer opens as it lands.
      const motion = window.BoonsoirMotion;
      const delay = motion && !reduceMotion.matches ? motion.flight(form, btn) : 0;
      if (delay > 0) setTimeout(() => openDrawer(btn), delay); else openDrawer(btn);
    } catch (err) {
      toast(err.message, 5000);
    } finally {
      releaseAdd();
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
    }
  });

  /* Line quantity / remove inside drawer */
  async function changeLine(key, quantity) {
    const d = getDrawer();
    if (d) d.setAttribute('aria-busy', 'true');
    try {
      const data = await postJSON(routes.cart_change_url + '.js', { id: key, quantity, sections: SECTIONS, sections_url: window.location.pathname });
      renderSections(data.sections);
    } catch (err) { toast(err.message, 5000); }
    finally { if (d) d.removeAttribute('aria-busy'); }
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-change]');
    if (!b || !b.closest(drawerSel)) return;
    e.preventDefault();
    changeLine(b.dataset.key, parseInt(b.dataset.quantity, 10));
  });

  /* ---------- Quantity steppers (product forms) ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b || b.closest(drawerSel)) return;
    const wrap = b.closest('.qty');
    const input = wrap && wrap.querySelector('input');
    if (!input) return;
    const min = parseInt(input.min || '1', 10);
    const max = input.max ? parseInt(input.max, 10) : 99;
    const next = Math.min(max, Math.max(min, (parseInt(input.value, 10) || min) + parseInt(b.dataset.qtyStep, 10)));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Entrance reveals ----------
     The reveal system lives in motion.js (masked lines, ink print, first-screen choreography).
     This is the fallback for when motion.js is missing: never leave content hidden. */
  function initReveal(scope = document) {
    if (window.BoonsoirMotion) { window.BoonsoirMotion.initReveal(scope); return; }
    scope.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-in', 'is-done'));
  }
  document.addEventListener('DOMContentLoaded', () => { if (!window.BoonsoirMotion) initReveal(); });
  window.addEventListener('load', () => { if (!window.BoonsoirMotion) initReveal(); });
  // Section effects ([data-fx]) hide content until section-fx.js arrives; never longer than 3 s.
  setTimeout(() => { if (!window.BoonsoirFX) document.querySelectorAll('[data-fx]').forEach((el) => el.classList.add('fx-in')); }, 3000);

  window.Boonsoir = Object.assign(window.Boonsoir || {}, { openDrawer, closeDrawer, renderSections, toast, initReveal, SECTIONS });
})();
